import { HeroType, HeroVideo } from '../types';
import { VideoCarousel } from '../components/VideoCarousel/VideoCarouselModal';

export interface SettingsTabPayload {
  playLogo: string;
  showLogoOnThumbnails: boolean;
  showOtherTeamsMatchClips: boolean;
  standardCategoryClipCount: number;
}

export const DEFAULT_STANDARD_CATEGORY_CLIP_COUNT = 10;

export interface CategoryModuleOrderEntry {
  type: 'category';
  category: string;
  channelIds: number[];
  title?: string;
}

export interface CustomCarouselModuleOrderEntry {
  type: 'custom-carousel';
  id: string;
  carouselId: string;
  title?: string;
}

export type ModuleOrderEntry = CategoryModuleOrderEntry | CustomCarouselModuleOrderEntry;

export interface StartTabPayload {
  heroType: HeroType;
  heroImage: string;
  heroVideo: HeroVideo | null;
  moduleOrder: ModuleOrderEntry[];
}

export interface VideoCarouselsTabPayload {
  carousels: VideoCarousel[];
}

export interface NotificationTabPayload {
  /** Placeholder until push/deeplink settings are persisted. */
}

export type FotbollPlayTabIndex = 0 | 1 | 2 | 3;

export interface FotbollPlayTabPayloadMap {
  0: SettingsTabPayload;
  1: StartTabPayload;
  2: VideoCarouselsTabPayload;
  3: NotificationTabPayload;
}

export interface FotbollPlayAppConfigPayload {
  settings?: SettingsTabPayload;
  start?: StartTabPayload;
  videoCarousels?: VideoCarouselsTabPayload;
  notifications?: NotificationTabPayload;
}

export interface FotbollPlayAppConfig extends FotbollPlayAppConfigPayload {
  teamAbbrv?: string;
  version?: number;
  createdAt?: unknown;
  updatedAt?: unknown;
}
